/**
 * useTheme composable — wraps the global state's theme slice.
 *
 * Reactive theme + toggleTheme() that flips light ↔ dark.
 * Persistence and applying the .dark class is handled in state.ts.
 */

import { computed } from 'vue';

import { state, type Theme } from '../state';

export function useTheme() {
  const theme = computed<Theme>(() => state.theme);
  const isDark = computed(() => state.theme === 'dark');

  function setTheme(next: Theme): void {
    state.theme = next;
  }

  function toggleTheme(): void {
    state.theme = state.theme === 'light' ? 'dark' : 'light';
  }

  return { theme, isDark, setTheme, toggleTheme };
}
